module.exports = __webpack_public_path__ + "media/app/assets/images/powerbank-thumb-5b86028a08f1c28004e55feb8dd88afc.jpg";